__webpack_require__.p = "https://omni.royalbank.com/bbp0/statics/business-onboarding-prequalification-ui/";